import { render, staticRenderFns } from "./powerorderDetail.vue?vue&type=template&id=26af8bae&scoped=true&"
import script from "./powerorderDetail.vue?vue&type=script&lang=js&"
export * from "./powerorderDetail.vue?vue&type=script&lang=js&"
import style0 from "./powerorderDetail.vue?vue&type=style&index=0&id=26af8bae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26af8bae",
  null
  
)

export default component.exports